export enum LaunchPadButtonColor {
  EMPTY = "#C4C4C4",
  ONESHOT = "#649FD4",
  LOOP_ODD = "#8F579F",
  LOOP_EVEN = "#265397",

  NOW_PLAYING = "#5FC7A6",
  NOW_WAIT = "#FF6240",
}
